import { LocaleContext } from '@melements/front-components/dist/context';
import React, { useContext } from 'react';
import { Button } from 'shared';
import { hasError } from 'utils';

import { DeleteButton, ErrorMessage, UploadedFile, UploadFieldInputWrapper } from './UploadFieldInput.styles';
import { UploadFieldProps } from './UploadFieldInput.types';

export const UploadFieldInput = ({
  className,
  meta,
  label,
  files,
  disabled,
  onSelectFiles,
  onRemove,
  children,
}: UploadFieldProps) => {
  const localeContext = useContext(LocaleContext);
  const isError = hasError(meta, false);

  return (
    <UploadFieldInputWrapper className={className}>
      {files.map((file, index) => (
        <UploadedFile key={index} className="upload-field__file">
          <span>{file.name}</span>
          <DeleteButton onClick={onRemove(index)}>{localeContext.formatMessage({ id: 'GENERAL.REMOVE' })}</DeleteButton>
        </UploadedFile>
      ))}

      {!disabled && (
        <Button
          type={'portal-dark'}
          icon={['1rem', 'plusDeepBlueIcon']}
          htmlType="button"
          onClick={onSelectFiles}
          className="upload-field__upload-button"
        >
          {label}
        </Button>
      )}

      {isError && <ErrorMessage className={`${className}__error`}>{meta.error || meta.submitError}</ErrorMessage>}

      {children}
    </UploadFieldInputWrapper>
  );
};
